export enum CoverageLevel {
    SELF = 1,
    SELF_SPOUSE = 2,
    SELF_CHILDREN = 3,
    FAMILY = 4
}

export enum ExpensesUsageOptionType {
    PREVIOUS_YEAR_USAGE = 'previousYear',
    LOW_USAGE = 'lowUsage',
    MEDIUM_USAGE = 'mediumUsage',
    HIGH_USAGE = 'highUsage',
    CUSTOM_USAGE = 'customUsage'
}

/**
 * The Service Types
 */
export enum ServiceType {
    MEDICAL = 'medical',
    PRESCRIPTION_DRUGS = 'prescriptionDrugs'
}

/**
 * The Service Categories displayed on the expenses options
 */
export enum ServiceCategoryType {
    PHYSICIAN_VISITS = 'PHV',
    SPECIALITY_VISITS = 'SPV',
    OUTPATIENT_SERVICES = 'OPS',
    GENERIC_RX = 'GRX'
}

export enum ComparePlansSegment {
    HRA_ROLLOVER_QUESTION = 'hra-rollover-question',
    PLANS_PREMIUM_HSA_INPUTS = 'plan-premium-hsa-inputs',
    COMPARISON_PLANS = 'comparison-plans',
    TAX_INCOME_QUESTION = 'tax-income-question'
}

export enum PlanType {
    HSA = 'HSA',
    HRA = 'HRA'
}
